module.exports = __webpack_public_path__ + "static/media/ispring_logo.be0906ef.svg";